import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  ButtonModel,
  IconSolidWarning,
  ModalContext,
  PictogramRegularInfoCheck,
  Text,
} from '@notino/react-styleguide';

import { useDrawer } from '@components/BottomSheet/DrawerProvider';

import { ModalHeader } from '../ReviewsFormModalBody/components/ModalHeader';

import { messages } from './messages';
import {
  DoneButton,
  InfoLine,
  ReviewSentText,
  ReviewSentThanksText,
  ReviewsSentSuccesModalWrapper,
} from './styled';

type Props = {
  someImagesFailed?: boolean;
  showTryAgainButton?: boolean;
  onTryAgainClick?: () => void;
};

export const ReviewsSentSuccessModalBody = ({
  someImagesFailed,
  showTryAgainButton,
  onTryAgainClick,
}: Props) => {
  const { hideModal } = ModalContext.useModalContext();
  const { hideDrawer } = useDrawer();

  const handleDone = () => {
    hideModal();
    hideDrawer();
  };

  return (
    <ReviewsSentSuccesModalWrapper data-cypress="reviewsModal-modalHeader">
      <ModalHeader isSuccessModal={true} />

      <div>
        <PictogramRegularInfoCheck height="72px" width="72px" />
        <ReviewSentText aria-live="polite">
          <FormattedMessage
            {...(someImagesFailed
              ? messages.reviewSentWithFailedImages
              : messages.reviewSent)}
          />
        </ReviewSentText>
        <ReviewSentThanksText>
          <FormattedMessage
            {...(someImagesFailed
              ? messages.reviewSendWithFailedImagesThanks
              : messages.reviewSentThanks)}
          />
        </ReviewSentThanksText>
      </div>

      {showTryAgainButton && (
        <InfoLine>
          <IconSolidWarning width="16px" height="16px" />
          <Text
            typography="labelSmall400"
            color="text.secondary"
            textAlign="start"
          >
            <FormattedMessage {...messages.infoLineSomeImagesFailed} />
          </Text>
          <button onClick={onTryAgainClick}>
            <FormattedMessage {...messages.tryAgain} />
          </button>
        </InfoLine>
      )}

      <DoneButton
        buttonStyle={ButtonModel.Styles.secondary}
        onClick={handleDone}
      >
        <FormattedMessage {...messages.done} />
      </DoneButton>
    </ReviewsSentSuccesModalWrapper>
  );
};
